<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Medical Record Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <app-teeth :activeTeeths="getActiveTeeths" v-on:teethClicked="addNewTeeth"></app-teeth>
        <div class="row">
            <div v-if="this.$route.query.id === undefined" class="form-group col-3">
                <label for="module">Patient Name</label>
                <app-lookup-field :model="medicalRecord" :element="patientLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div v-if="this.$route.query.id !== undefined" class="form-group col-3">
                <label>Patient Name</label>
                <input type="text" class="form-control" v-model="medicalRecord.patientName" disabled id="patientName" aria-describedby="action">
            </div>
        </div>
        <app-datatable :type="'input'" :newData="medicalRecordDetail" :elements="dtElementsDetail" :collections="medicalRecord.detail"></app-datatable>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { MedicalRecord, MedicalRecordDetail } from '../../models/medicalRecord'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppTeeth from '../../components/AppTeeth.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar, AppTeeth
    },
    data() {
        return {
            medicalRecord: {
                ...MedicalRecord,
                detail: [],
            },
            medicalRecordDetail: MedicalRecordDetail,
            patientLookup: {
                id: 'patient',
                title: 'Patient',
                type: 'form',
                apiUrl: 'patient-list',
                filter: ['name', 'address'],
                fields: [
                    {
                        placeholder: 'Patient',
                        width: 12,
                        column: 'patientName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Patient Name',
                        column: 'name'
                    },
                    {
                        title: 'Patient Age',
                        column: 'patientAge'
                    },
                    {
                        title: 'Patient DoB',
                        column: 'dateOfBirth',
                        type: 'date',
                    },
                    {
                        title: 'Patient Address',
                        column: 'address'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'patientId'
                    },
                    {
                        from: 'name',
                        to: 'patientName'
                    },
                ]
            },
            dtElementsDetail: [
            {
                title: 'Date',
                column: 'date',
                type: 'date',
                width: 4,
            },
            {
                title: 'Regio',
                column: 'teeth',
                type: 'text',
                width: 4,
            },
            {
                title: 'Anamnesa/Diagnosa',
                column: 'description',
                type: 'text',
                width: 4,
            },
            {
                title: 'Treatment Type',
                column: 'treatmentType',
                type: 'text',
                width: 4,
            },
            {
                title: 'Treatment',
                column: 'treatmentName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'treatment-list',
                    title: 'Treatment List',
                    type: 'selectable-table',
                    objectName: 'treatment',
                    construct: 'treatment',
                    rowAttribute: 'medicalRecordDetail',
                    needAutoClose: false,
                    apiUrl: 'treatment-list',
                    filter: ['name', 'code'],
                    fields: [
                        {
                            placeholder: 'Treatment Name',
                            width: 5,
                            column: 'treatmentName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'Treatment Code',
                            column: 'code'
                        },
                        {
                            title: 'Treatment Name',
                            column: 'name'
                        },
                        {
                            title: 'Treatment Price',
                            column: 'price',
                            type: 'currency'
                        },
                        {
                            title: 'Raw Material Price',
                            column: 'rawMaterialPrice',
                            type: 'currency',
                            hidden: true
                        },
                    ],
                    affectedField: [
                        {
                            from: 'price',
                            to: 'totalAfterPercent',
                            needSum: true,
                        },
                        {
                            from: 'rawMaterialPrice',
                            to: 'rawMaterialPrice',
                            needSum: true,
                        },
                    ]
                },
                disable: true,
            },
            {
                title: 'Medicine',
                column: 'suppliesName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'supplies-list',
                    title: 'Supplies List',
                    type: 'selectable-table',
                    objectName: 'supplies',
                    construct: 'supplies',
                    rowAttribute: 'medicalRecordDetail',
                    needAutoClose: false,
                    apiUrl: 'supplies-list',
                    filter: ['name'],
                    fields: [
                        {
                            placeholder: 'Supplies Name',
                            width: 5,
                            column: 'suppliesName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'Supplies Name',
                            column: 'name'
                        },
                        {
                            title: 'Remarks',
                            column: 'remarks',
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'suppliesId'
                        },
                        {
                            from: 'name',
                            to: 'suppliesName'
                        },
                    ]
                },
                disable: true,
            },
            {
                title: 'Dentist',
                column: 'handledByName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'doctor-lookup',
                    title: 'Handled By',
                    byParams: true,
                    type: 'table',
                    apiUrl: 'member-management-list-by-role',
                    filter: ['memberName'],
                    params: [
                        {
                            key: 'role',
                            value: 'role',
                        }
                    ],
                    fields: [
                        {
                            placeholder: 'Doctor Name',
                            width: 5,
                            column: 'handledByName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'Doctor Name',
                            column: 'memberName'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'handledBy'
                        },
                        {
                            from: 'memberName',
                            to: 'handledByName'
                        },
                    ]
                },
                disable: true,
            },
            {
                title: 'Price',
                column: 'totalAfterPercent',
                type: 'currency',
                width: 4,
                disable: true,
            },
              {
                title: 'Payable',
                column: 'isPayable',
                type: 'dropdown',
                width: 4,
                lists: [
                    {
                        title: 'No',
                        value: false,
                    },
                    {
                        title: 'Yes',
                        value: true,
                    },
                ]
              },
              {
                title: 'Discount(%)',
                column: 'discount',
                type: 'number',
                width: 4,
              },
            {
                title: 'Subtotal',
                column: 'subtotal',
                type: 'currency',
                width: 4,
                disable: true,
            },
          ],
        }
    },
    computed: {
        getActiveTeeths() {
            console.log('jana');
            console.log(this.medicalRecord.detail.map((t) => t.teeth))
            return this.medicalRecord.detail.map((t) => t.teeth);
        },
    },
    watch: {
        'medicalRecord.detail': {
            handler: function() {
                // watch deeply for every changes on rsdetail to calculate sample cost
                for(let i=0; i<this.medicalRecord.detail.length;i++) {
                    if(Math.round(this.medicalRecord.detail[i].discount) === 0) {
                        this.medicalRecord.detail[i].subtotal = this.medicalRecord.detail[i].totalAfterPercent 
                    } else {
                        this.medicalRecord.detail[i].subtotal = ( this.medicalRecord.detail[i].totalAfterPercent - Math.round((this.medicalRecord.detail[i].totalAfterPercent * this.medicalRecord.detail[i].discount / Math.round(100))))
                    }
                    // this.medicalRecord.detail[i].subtotal = this.medicalRecord.detail[i].totalAfterPercent 
                    //this.medicalRecord.detail[i].subtotal = this.medicalRecord.detail[i].totalAfterPercent - (this.medicalRecord.detail[i].totalAfterPercent * this.rs.requestSampleDetail[i].discount / 100)
                }
            },
            deep: true
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const mrApi = api('medical-record/detail')

            const medicalRecordResult = await mrApi.getWithParams(this.$route.query.id)
            this.medicalRecord = medicalRecordResult
            console.log(this.medicalRecord);
        }
    },
    methods: {
        async save() {
            const mrApi = api('medical-record')
            if(this.$route.query.id !== undefined) {
                await mrApi.update(this.medicalRecord, this.$route.query.id)
            } else {
                await mrApi.create(this.medicalRecord)
            }
            // this.$router.push({ name: 'medicalRecord' })
            this.$router.go(-1)
        },
        cancel() {
            // this.$router.push({ name: 'medicalRecord' })
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentMedical = this.medicalRecord
            this.medicalRecord = {
                ...currentMedical,
                ...data
            }
        },
        selectChange(data) {
            const currentMedical = this.medicalRecord
            this.medicalRecord = {
                ...currentMedical,
                ...data
            }
        },
        addNewTeeth(value) {
            if (value !== '') {
                console.log('value di parent', value);
                this.medicalRecord.detail = [...this.medicalRecord.detail, {...this.medicalRecordDetail, teeth: value}]
            }
        }
    }
}
</script>